// extracted by mini-css-extract-plugin
export default {"removeImageButtonWrap":"RemoveImageButton_removeImageButtonWrap__Ssx+J","removeImageButton":"RemoveImageButton_removeImageButton__Ry1Zn"};